import { ICON_SELECTOR } from '@/enum/Selectors';

/**
 * CSS selector for elements that should have font size adjusted
 */
const FONT_SIZE_SELECTOR = 'h1,h2,h3,h4,h5,h6,p,a,dl,dt,li,ol,th,td,span,blockquote,.cya11y-text,div,button';

/**
 * Set of icon selectors to exclude from font size adjustments
 */
const ICON_SELECTOR_SET = new Set(ICON_SELECTOR);

/**
 * Data attribute key for storing original font size
 */
const ORIGINAL_FONT_SIZE_ATTR = 'cya11yOrgFontSize';

/**
 * Adjusts font size of text elements on the page
 * @param multiply - Font size multiplier (default: 1)
 * @returns void
 */
export default function adjustFontSize(multiply: number = 1): void {
  try {
    if (typeof multiply !== 'number' || multiply <= 0) {
      console.warn('Invalid font size multiplier:', multiply);
      return;
    }

    const elements = document.querySelectorAll<HTMLElement>(FONT_SIZE_SELECTOR);
    
    elements.forEach((element: HTMLElement) => {
      try {
        // Skip elements that contain any class in ICON_SELECTOR_SET
        if (Array.from(element.classList).some(cls => ICON_SELECTOR_SET.has(cls))) {
          return;
        }

        // Get the original font size from data attribute or computed style
        let originalFontSize = Number(element.dataset[ORIGINAL_FONT_SIZE_ATTR]) || 
                              parseInt(window.getComputedStyle(element).fontSize);

        // Validate font size
        if (isNaN(originalFontSize) || originalFontSize <= 0) {
          console.warn('Invalid original font size for element:', element);
          return;
        }

        // Store original font size in data attribute if not already stored
        if (!element.dataset[ORIGINAL_FONT_SIZE_ATTR]) {
          element.dataset[ORIGINAL_FONT_SIZE_ATTR] = String(originalFontSize);
        }

        // Calculate and apply new font size
        const newFontSize = originalFontSize * multiply;
        element.style.fontSize = `${newFontSize.toFixed(0)}px`;
      } catch (elementError) {
        console.warn('Failed to adjust font size for element:', element, elementError);
      }
    });
  } catch (error) {
    console.error('Failed to adjust font size:', error);
  }
}